/*! Wi-activity v1.0.0
 * https://wicode.pl/
 * Copyright (c) 2017 Wicode;
 */

(function () {
    'use strict';

    let loadNewActivity = true;

    const wiActivity = {
        activityArea: null,

        init() {
            this.activityArea = document.getElementById('activity_area');
            if (this.activityArea) {
                setTimeout(() => {
                    this.get(referral_id, referral_type);
                    setInterval(() => {
                        if (loadNewActivity) {
                            this.get(referral_id, referral_type);
                        }
                    }, 10000);
                }, 2000);
            }
            this.events();
        },

        events() {
            const handleCheckTabActivity = this.handleCheckTabActivity.bind(this);
            let tabClicked = false;
            
            $(document).on('click', '.check-tab-activity[data-toggle="tab"]', function (e) {
                tabClicked = true;
                handleCheckTabActivity(e);
            });
            $(document).on('show.bs.tab', '.check-tab-activity[data-toggle="tab"]', function (e) {
                if (!tabClicked) {
                    handleCheckTabActivity(e);
                }
                tabClicked = false;
            });

            $(document).on('show.bs.collapse', '.check-tab-activity', handleCheckTabActivity);
            $(document).on('summernote.focus', handleCheckTabActivity);
        },

        handleCheckTabActivity(event) {
            const triggerElement = event.target.closest('.editor-activity') || event.currentTarget;

            if (!(triggerElement instanceof HTMLElement)) {
                return;
            }

            const targetSelector = triggerElement.getAttribute('data-target');
            let target = targetSelector ? document.querySelector(targetSelector) : null;

            if (!target) {
                target = triggerElement.closest('.editor-activity');
            }
            if (!target) {
                return;
            }
            
            this.setReaded(
                target.getAttribute('data-referral-id'),
                target.getAttribute('data-referral-type'),
                target.getAttribute('data-subreferral-id'),
                target.getAttribute('data-subreferral-type'),
                target.getAttribute('data-target-type'),
            );
        },

        get(r_id, r_type) {
            if (!this.activityArea) {
                return;
            }
            loadNewActivity = false;

            fetch(`${urls.activity}/get_activity?referral_id=${r_id}&referral_type=${r_type}&language_id=${language_id}&csrf_wicode=${csrf_value}`)
                    .then(res => res.json())
                    .then(data => {
                        this.activityArea.innerHTML = data.activity;
                        this.updateCounts(data.counts);
                        this.updateReferralCounts(data.referralCounts);
                    })
                    .catch(console.error)
                    .finally(() => {
                        if (typeof wiLayout !== 'undefined' && typeof wiLayout.bootstrap === 'function') {
                            wiLayout.bootstrap();
                        }
                        loadNewActivity = true;
                    });
        },

        cap(n) {
            return n > 99 ? '99+' : n;
        },

        updateCounts(counts) {
            for (const key in counts) {
                if (key !== 'overall') {
                    const badge = document.getElementById(`activity_${key}_badge`);
                    if (badge) {
                        badge.innerHTML = counts[key] > 0
                                ? `<span class="badge active">${this.cap(counts[key])}</span>`
                                : '';
                    }
                }
            }
        },

        updateReferralCounts(referralCounts) {
            for (const key in referralCounts) {
                for (const id in referralCounts[key]) {
                    const row = referralCounts[key][id];
                    const badgeContainer = document.getElementById(`activity_${key}${id}_badge`);

                    if (!badgeContainer) {
                        continue;
                    }

                    let badge = row.new > 0
                            ? `<span class="badge active">${this.cap(row.new)}</span>`
                            : (row.overall ? `<span class="badge">${this.cap(row.overall)}</span>` : '');

                    if (row.media) {
                        const isNew = row.media.new > 0;
                        this.update(isNew, document.getElementById(`media-tab-${id}`));
                        badge += this.badge(row.media, isNew, 'fa-picture-o');
                    }

                    if (key === 'tasks') {
                        const isNew = row.new > 0;
                        this.update(isNew, document.getElementById(`tasks${id}`));
                        badge = this.badge(row, isNew, 'fa-comments');
                    }

                    if (row.comments) {
                        const isNew = row.comments.new > 0;
                        badge += this.badge(row.comments, isNew, 'fa-comments');
                    }

                    badgeContainer.innerHTML = badge;
                }
            }
        },

        update(isNew, el) {
            if (!isNew || !(el && el.offsetParent !== null))
                return;
            el.setAttribute('data-ajax-loaded', 'false');
        },

        badge(data, isNew, icon) {
            return `<span>` +
                    `<i class="fa fa-fw fa-left ${icon}"></i>` +
                    (isNew ? `<span class="badge active">${this.cap(data.new)}</span>` :
                            (data.overall > 0 ? `<span class="badge">${this.cap(data.overall)}</span>` : '')) +
                    `</span>`;
        },

        setReaded(r_id, r_type, sr_id, sr_type, t_type) {
            const formData = new FormData();
            formData.append('referral_id', r_id);
            formData.append('referral_type', r_type);
            formData.append('subreferral_id', sr_id);
            formData.append('subreferral_type', sr_type);
            formData.append('target_type', t_type);
            formData.append('language_id', language_id);
            formData.append('csrf_wicode', csrf_value);

            fetch(`${urls.activity}/set_readed`, {
                method: 'POST',
                body: formData
            })
                    .then(res => res.json())
                    .then(() => {
                        if (loadNewActivity) {
                            this.get(r_id, r_type);
                        }
                    });
        }
    };

    window.wiActivity = {
        get: wiActivity.get.bind(wiActivity),
        init: wiActivity.init.bind(wiActivity),
        setReaded: wiActivity.init.bind(wiActivity)
    };

    if (document.readyState !== 'loading') {
        wiActivity.init();
    } else {
        document.addEventListener('DOMContentLoaded', () => {
            wiActivity.init();
        });
    }
})();